import { useRef } from 'react';

import { HistogramGenericCanvasLayout } from './HistogramGenericCanvasLayout.js';
import { HistogramHighlightedCanvasLayout } from './HistogramHighlightedCanvasLayout.js';
import { type CanvasRef } from '../../../core/components/canvas/Canvas.js';
import { plotLayout } from '../../../core/components/chart-grid/ChartGrid.sty.js';
import { useHistogramFilteredData } from '../../hooks/useHistogramFilteredData.js';

export const HistogramCanvasLayout = () => {
  const canvasRef = useRef<CanvasRef>(null);
  const { series } = useHistogramFilteredData();

  const handleOpacityChange = (value: string) => {
    if (canvasRef && canvasRef.current) {
      // It's done through direct DOM manipulation since canvas elements are not React components and we want to avoid re-renders
      canvasRef.current.customSetStyle('opacity', value);
    }
  };

  return (
    <>
      <div data-testid="histogram-canvas" className={plotLayout}>
        <HistogramGenericCanvasLayout ref={canvasRef} series={series} />
      </div>
      <div className={plotLayout}>
        <HistogramHighlightedCanvasLayout handleOpacity={handleOpacityChange} />
      </div>
    </>
  );
};

HistogramCanvasLayout['displayName'] = 'HistogramCanvasLayout';
